module.exports = __webpack_public_path__ + "static/media/data-explorer.e6282d56.png";